var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNavSparkle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8l1.25-2.75L22 4l-2.75-1.25L18 0l-1.25 2.75L14 4l2.75 1.25L18 8zM18 14l-1.25 2.75L14 18l2.75 1.25L18 22l1.25-2.75L22 18l-2.75-1.25L18 14zM10.5 8.5L8 3 5.5 8.5 0 11l5.5 2.5L8 19l2.5-5.5L16 11l-5.5-2.5zm-1.51 3.49L8 14.17l-.99-2.18L4.83 11l2.18-.99L8 7.83l.99 2.18 2.18.99-2.18.99z",
    fill: "#123133"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNavSparkle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nav-sparkle.4da26c484c53e10f722e7dfcc9f2e1bd.svg";